import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

export interface BreakpointsUtilityState extends BreakpointState {}

@Injectable({
  providedIn: 'root',
})
export class BreakpointsUtilityService {
  constructor(public breakpointObserver: BreakpointObserver) {}

  public observe$(breakpoints: string | readonly string[]): Observable<BreakpointsUtilityState> {
    return this.breakpointObserver.observe(breakpoints);
  }
}
